import { createFileRoute } from "@tanstack/react-router";

import { SubscriptionAccountsPage } from "../components/settings/SubscriptionAccountsPage";

function SettingsSubscriptionAccountsRoute() {
  return <SubscriptionAccountsPage />;
}

export const Route = createFileRoute("/settings/subscription-accounts")({
  component: SettingsSubscriptionAccountsRoute,
});
